import { useState } from "react";
import { Link } from "react-router-dom";

const LandingPage = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="landing-wrapper">
      <img
        src="/images/splash_image.png"
        alt="Bilingual Logo"
        className="logo-img"
        width="500"
        height="125"
        fetchpriority="high"
      />

      <div className="description">
        <p className="arabic-text">
          تستعرض هذه الأداة التفاعلية طُرقًا تُتيح للكتابة العربية واللاتينية
          التواجد معًا ضمن منشور أو مجلد واحد. كما أن هذه المنصّة، التي أنشأتها
          يارا خوري (من «وحدة الخط العربي» في الجامعة الأمريكية في بيروت)، تعرض
          صيغًا مختلفة لهياكل كتب ثنائية الكتابة. وبذلك، تُوفّر مرجعًا مبنيًا
          على البحث العلمي لكلٍّ من المصمّمين والمعلّمين الذين يتعاملون مع أنظمة
          كتابة مختلفة.
        </p>
        <p className="english-text">
          This interactive toolkit explores ways Arabic and Latin scripts can
          coexist in a bound publication. Created by Yara Khoury Nammour at the
          Arabic Type Unit (ATU, American University of Beirut), the platform
          visualizes different biscriptal book formats, offering a
          research-based resource for designers and educators working across
          scripts.
        </p>
      </div>

      <div className="btn-group">
        <button onClick={() => setShowVideo(true)} className="black-btn">
          <span>مشاهدة التعليمات</span>
          <span>Watch Tutorial</span>
        </button>

        <Link to="/main" className="white-btn">
          <span>دخول الموقع</span>
          <span>Enter Website</span>
        </Link>
      </div>

      <div className="disclaimer">
        <p className="arabic-text" dir="rtl">
          تم إطلاق هذا البحث من قبل «وحدة الخط العربي» في الجامعة الأمريكية في
          بيروت (AUB) بدعم من مجلس البحوث الجامعية في. كما اكتمل، بما في ذلك من
          تصميم وتطوير المنصة الإلكترونية، بدعم من منحة حصل عليها من خلال
          «برنامج البحث في الفنون» الدورة الثالثة (2021-2022)، من الصندوق العربي
          للثقافة والفنون والمجلس العربي للعلوم الاجتماعية بتمويل من مؤسسة أندرو
          و. ميلون. الآراء المعبّر عنها في هذا الإنتاج هي آراء صانعيها والأشخاص
          الذين تمت مقابلتهم ولا تمثل بالضرورة آراء المجلس العربي للعلوم
          الاجتماعية.
        </p>
        <p className="english-text">
          This research is initiated by the Arabic Type Unit at the American
          University of Beirut (AUB) with the support of the University Research
          Board at AUB. This research was completed with the support of a grant
          received through the “Research on the Arts Program” Third Cycle
          (2022–2023), from the Arab Fund for Arts and Culture and the Arab
          Council for the Social Sciences funded by The Andrew W. Mellon
          Foundation. The views expressed in this production are those of its
          makers and interviewees and do not necessarily represent those of the
          ACSS.
        </p>
      </div>

      {showVideo && (
        <div className="video-modal" onClick={() => setShowVideo(false)}>
          <div className="video-container" onClick={(e) => e.stopPropagation()}>
            <video controls autoPlay>
              <source
                src="/vid/bilingualwebsite-tutorial.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <button className="close-btn" onClick={() => setShowVideo(false)}>
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
